import FuseAnimate from '@fuse/core/FuseAnimate';
import Card from '@material-ui/core/Card';
import CardContent from '@material-ui/core/CardContent';
import { makeStyles } from '@material-ui/core/styles';
import { darken } from '@material-ui/core/styles/colorManipulator';
import Typography from '@material-ui/core/Typography';
import clsx from 'clsx';
import React, { useState, useEffect } from 'react';
import { Link, useLocation, useHistory } from 'react-router-dom';
// import Auth0LoginTab from './tabs/Auth0LoginTab';
import FirebaseLoginTab from './tabs/FirebaseLoginTab';
/* Added the following code for POW-872.Harsha using AI Agent. July 9, 2026. Code Start */
import CandidateLoginTab from './tabs/CandidateLoginTab';
import CandidateSignupTab from './tabs/CandidateSignupTab';
import Button from '@material-ui/core/Button';
/* Added the following code for POW-950.Harsha using AI Agent. October 7, 2026. Code Start */
import PartnerLoginTab from './tabs/PartnerLoginTab';
import PartnerSignupTab from './tabs/PartnerSignupTab';
/* Code end. Harsha using AI Agent. October 7, 2026 */
/* Code end. Harsha using AI Agent. July 9, 2026 */
// import JWTLoginTab from './tabs/JWTLoginTab';
import './tabs/login.css'

const useStyles = makeStyles(theme => ({
	root: {
		background: `linear-gradient(to right, #243689 0%, ${darken(
			"#132147",
			0.5
		)} 70%)`,
		color: theme.palette.primary.contrastText
	},
	imagesize: {
		marginBottom: "-25px",
		width: "20rem",
		alignSelf: 'center'
	}
}));

function Login() {
	const classes = useStyles();
	const location = useLocation();
	const history = useHistory();
	/* Added the following code for POW-872.Harsha using AI Agent. July 13, 2026. Code Start */
	const [loginMode, setLoginMode] = useState('recruiter');
	const [candidateView, setCandidateView] = useState('login');

	useEffect(() => {
		const params = new URLSearchParams(location.search);
		const mode = params.get('mode');
		const view = params.get('view');

		/* Added the following code for POW-950.Harsha using AI Agent. October 7, 2026. Code Start */
		if (mode === 'candidate') {
			setLoginMode('candidate');
		} else if (mode === 'partner') {
			setLoginMode('partner');
		} else {
			setLoginMode('recruiter');
		}
		/* Code end. Harsha using AI Agent. October 7, 2026 */
		if (view === 'signup') {
			setCandidateView('signup');
		} else {
			setCandidateView('login');
		}
	}, [location.search]);

	const openRecruiterLogin = () => {
		setLoginMode('recruiter');
		setCandidateView('login');
		history.replace('/');
	};

	const openCandidateLogin = () => {
		setLoginMode('candidate');
		setCandidateView('login');
		history.replace('/?mode=candidate');
	};

	const openCandidateSignup = () => {
		setLoginMode('candidate');
		setCandidateView('signup');
		history.replace('/?mode=candidate&view=signup');
	};

	/* Added the following code for POW-950.Harsha using AI Agent. October 7, 2026. Code Start */
	const openPartnerSignup = () => {
		setLoginMode('partner');
		setCandidateView('signup');
		history.replace('/?mode=partner&view=signup');
	};

	const openPartnerLogin = () => {
		setLoginMode('partner');
		setCandidateView('login');
		history.replace('/?mode=partner');
	};
	/* Code end. Harsha using AI Agent. October 7, 2026 */

	const backToCandidateLogin = () => {
		setCandidateView('login');
		history.replace(loginMode === 'partner' ? '/?mode=partner' : '/?mode=candidate');
	};

	/* Added the following code for POW-950.Harsha using AI Agent. October 9, 2026. Code Start */
	const showSignupPending = () => {
		setCandidateView('signup-pending');
	};

	const isCandidateSignup = (loginMode === 'candidate' || loginMode === 'partner')
		&& (candidateView === 'signup' || candidateView === 'signup-pending');
	const isSignupPending = candidateView === 'signup-pending';
	/* Code end. Harsha using AI Agent. October 9, 2026 */
	/* Code end. Harsha using AI Agent. July 13, 2026 */

	return (
		<div className={clsx(classes.root, 'flex flex-col flex-1 flex-shrink-0 p-24 md:flex-row md:p-0', isCandidateSignup && 'login-page-signup-active')}>
			<div className="flex flex-col flex-grow-0 items-center text-white p-16 text-center login-div md:items-start md:flex-shrink-0 md:flex-1 md:text-left">
				<FuseAnimate animation="transition.expandIn">
					<img className="w-128 mb-32" src="assets/images/logos/logo5.png" alt="logo" className={classes.imagesize} />
				</FuseAnimate>
				<FuseAnimate delay={400}>
					<Typography variant="h6" color="inherit" className="max-w-512 mt-16 login-h66" style={{ marginTop: "-20px" , marginLeft: '20%'}}>
						Empowering Recruiters, Enabling Candidates
					</Typography>
				</FuseAnimate>

				<FuseAnimate animation="transition.slideUpIn" delay={300}>
					<Typography variant="h3" color="inherit" className="font-light login-h6">
						{/* Added the following code for POW-872.dharma using AI Agent. July 23, 2026. Code Start */}
						{loginMode === 'candidate'
							? 'Discover Opportunities, Build Your Career'
							: loginMode === 'partner'
								? 'Partner With Us, Submit Top Talent'
							: (
								<>
									{/* Commenting the following code for POW-650. Prasanna. April 29 2025.. Code Start*/}
									{/*Welcome to the PowerRecruit !*/}
									{/*Commenting end.  Prasanna. April 29 2025..*/}
									{/* Added this code for  POW-649. Prasanna. April 28 2025.. Code Start */}
									Welcome to PowerRecruit !
									{/* Prasanna. April 29 2025.. Code End */}
								</>
							)}
						{/* Code end. dharma using AI Agent. July 23, 2026 */}
					</Typography>
				</FuseAnimate>
			<div className="sub-div">
				{/* Added the following code for POW-872.dharma using AI Agent. July 23, 2026. Code Start */}
				{(loginMode === 'candidate'
					? [
						'Create or Update Your Profile',
						'Search Available Jobs',
						'Review Job Details',
						'Apply for Suitable Positions',
						'Track Your Applications'
					]
					: loginMode === 'partner'
						? [
							'Create Your Partner Account',
							'Browse Open Jobs',
							'Submit Multiple Candidates per Job',
							'Track Your Submissions'
						]
					: [
						'Upload Your Job',
						'Search for Candidates',
						'Review Best Matching Candidates',
						'Select and activate chatbot',
						'Call and submit'
					]
				).map((item, index) => (
					<FuseAnimate key={item} delay={400}>
						<Typography variant="subtitle1" color="inherit" className="max-w-512 mt-16" style={{ marginTop: "-20px", marginLeft: '20%' }}>
							{item}
						</Typography>
					</FuseAnimate>
				))}
				{/* Code end. dharma using AI Agent. July 23, 2026 */}
			</div>

			</div>

			<FuseAnimate animation={{ translateX: [0, '100%'] }}>
				{/* Added the following code for POW-950.Harsha using AI Agent. October 9, 2026. Code Start */}
				<Card className={clsx('w-full max-w-400 mx-auto m-16 md:m-0 square login-panel-card', isCandidateSignup && 'login-signup-card')}>
				{/* Code end. Harsha using AI Agent. October 9, 2026 */}
					<CardContent
						className={clsx(
							'flex flex-col w-full p-32',
							isCandidateSignup
								? 'login-signup-card-content'
								: 'items-center justify-center md:p-48 md:pt-128'
						)}
					>
						{isCandidateSignup ? (
							<div className="candidate-signup-panel">
								{isSignupPending ? (
									<div className="signup-pending-panel">
										<div className="signup-pending-icon" aria-hidden="true">✓</div>
										<Typography variant="h5" className="signup-pending-title">
											Thank you for signing up!
										</Typography>
										<Typography variant="body1" className="signup-pending-message">
											Your registration request has been submitted successfully. Our admin team will review
											your application and you will receive an email once your account is approved.
										</Typography>
										<Button
											type="button"
											variant="contained"
											color="primary"
											className="normal-case signup-pending-back-btn"
											onClick={backToCandidateLogin}
										>
											Back to login
										</Button>
									</div>
								) : (
									<>
										{/* Added the following code for POW-950.Harsha using AI Agent. October 9, 2026. Code Start */}
										<div className="candidate-signup-header">
											<button
												type="button"
												className="font-medium candidate-signup-back"
												onClick={backToCandidateLogin}
											>
												← Back to login
											</button>
											<Typography variant="h6" className="text-center md:w-full signup-panel-title">
												{loginMode === 'partner' ? 'CREATE PARTNER ACCOUNT' : 'CREATE CANDIDATE ACCOUNT'}
											</Typography>
										</div>
										<div className="candidate-signup-scroll">
											{loginMode === 'partner'
												? <PartnerSignupTab onBackToLogin={backToCandidateLogin} onSignupSuccess={showSignupPending} />
												: <CandidateSignupTab onBackToLogin={backToCandidateLogin} onSignupSuccess={showSignupPending} />}
										</div>
										{/* Code end. Harsha using AI Agent. October 9, 2026 */}
									</>
								)}
							</div>
						) : (
							<>
								<Typography variant="h6" className="text-center md:w-full mb-48">
									LOGIN TO YOUR ACCOUNT
								</Typography>

								{/* Added the following code for POW-872.Harsha using AI Agent. July 9, 2026. Code Start */}
								{/* Added the following code for POW-950.Harsha using AI Agent. October 9, 2026. Code Start */}
								<div className="login-account-type-row">
									<Button
										type="button"
										variant="outlined"
										disableElevation
										className={clsx('login-account-type-btn', loginMode === 'recruiter' && 'login-account-type-btn-active')}
										onClick={openRecruiterLogin}
									>
										Recruiter
									</Button>
									<Button
										type="button"
										variant="outlined"
										disableElevation
										className={clsx('login-account-type-btn', loginMode === 'candidate' && 'login-account-type-btn-active')}
										onClick={openCandidateLogin}
									>
										{/* Added the following code for No Ticket.Harsha using AI Agent. October 28, 2026. Code Start */}
										Applicant
										{/* Code end. Harsha using AI Agent. October 28, 2026 */}
									</Button>
									<Button
										type="button"
										variant="outlined"
										disableElevation
										className={clsx('login-account-type-btn', loginMode === 'partner' && 'login-account-type-btn-active')}
										onClick={openPartnerLogin}
									>
										Partner
									</Button>
								</div>
								{/* Code end. Harsha using AI Agent. October 9, 2026 */}
								{loginMode === 'recruiter' && <FirebaseLoginTab />}
								{loginMode === 'candidate' && candidateView === 'login' && (
									<CandidateLoginTab onShowSignup={openCandidateSignup} />
								)}
								{/* Added the following code for POW-950.Harsha using AI Agent. October 7, 2026. Code Start */}
								{loginMode === 'partner' && candidateView === 'login' && (
									<PartnerLoginTab onShowSignup={openPartnerSignup} />
								)}
								{/* Code end. Harsha using AI Agent. October 7, 2026 */}
								{/* Code end. Harsha using AI Agent. July 9, 2026 */}
								{loginMode === 'recruiter' || ((loginMode === 'candidate' || loginMode === 'partner') && candidateView === 'login') ? (
									<div style={{ marginTop: "6px" }}>
										{loginMode === 'recruiter' ? (
											<>
												<Link className="font-medium" to="/forgotpass">
													Forgot password
												</Link>
												<Link className="font-medium" to="/forgotuser" style={{ marginLeft: "70px" }}>
													Forgot username
												</Link>
											</>
										) : (
											<Link className="font-medium" to="/forgotpass">
												Forgot password
											</Link>
										)}
									</div>
								) : null}

								<div className="flex flex-col items-center justify-center pt-32" />
							</>
						)}
					</CardContent>
				</Card>
			</FuseAnimate>
		</div>
	);
}

export default Login;
